'use strict';

var _regeneratorRuntime = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var configure = require('../lib/configure');

var toFormData = require('../lib/buffer-to-form-data');

var modeToString = require('../lib/mode-to-string');

var mtimeToObject = require('../lib/mtime-to-object');

module.exports = configure(function (_ref) {
  var ky = _ref.ky;
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(path, input, options) {
      var mtime, searchParams, res;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              options = options || {};
              mtime = mtimeToObject(options.mtime);
              searchParams = new URLSearchParams(options.searchParams);
              searchParams.set('arg', path);
              searchParams.set('stream-channels', true);
              if (options.cidVersion) searchParams.set('cid-version', options.cidVersion);
              if (options.create != null) searchParams.set('create', options.create);
              if (options.hashAlg) searchParams.set('hash', options.hashAlg);
              if (options.length != null) searchParams.set('length', options.length);
              if (options.offset != null) searchParams.set('offset', options.offset);
              if (options.parents != null) searchParams.set('parents', options.parents);
              if (options.rawLeaves != null) searchParams.set('raw-leaves', options.rawLeaves);
              if (options.truncate != null) searchParams.set('truncate', options.truncate);
              if (options.shardSplitThreshold != null) searchParams.set('shardSplitThreshold', options.shardSplitThreshold);

              if (mtime) {
                searchParams.set('mtime', mtime.secs);

                if (mtime.nsecs != null) {
                  searchParams.set('mtimeNsecs', mtime.nsecs);
                }
              }

              _context.next = 17;
              return ky.post('files/write', {
                timeout: options.timeout,
                signal: options.signal,
                headers: options.headers,
                searchParams: searchParams,
                body: toFormData(input, {
                  mode: options.mode != null ? modeToString(options.mode) : undefined,
                  mtime: mtime ? mtime.secs : undefined,
                  mtimeNsecs: mtime ? mtime.nsecs : undefined
                }) // TODO: support inputs other than buffer as per spec

              });

            case 17:
              res = _context.sent;
              return _context.abrupt("return", res.text());

            case 19:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x, _x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }();
});